import { useEffect } from 'react';

// Warns the agent before the browser unloads (tab close / refresh / external
// navigation) while there are unsaved booking edits, so contact/ticket changes
// aren't silently lost. In-app SPA navigation is not intercepted: the app uses
// <BrowserRouter> rather than a data router, so react-router's useBlocker is
// unavailable here.
export default function useUnsavedChangesWarning(hasUnsavedChanges) {
    useEffect(() => {
        if (!hasUnsavedChanges) return undefined;
        const handler = (event) => {
            event.preventDefault();
            // Chrome shows the native prompt only when returnValue is a non-empty
            // string; an empty string fires the event but renders no dialog.
            event.returnValue = 'You have unsaved changes.';
        };
        window.addEventListener('beforeunload', handler);
        return () => window.removeEventListener('beforeunload', handler);
    }, [hasUnsavedChanges]);
}
